<template>
    <left-side-filters
        :filters="filters"
        :module-name="moduleName"
        @apply-filters="applyFilters"
    >
        <template #after-filters>
            <a
                class="pr-xl-3"
                :href="`/help-tutorials/Rozliczenie_retr_-_instrukcja.pdf`"
                download
            >
                <the-btn
                    class="mt-md-3 mb-3 mb-lg-0 w-100"
                    icon="Download"
                    text="Pobierz instrukcję"
                />
            </a>
        </template>
        <template #content>
            <div class="c-settings flex-row pt-1 gap-1">
                <sub-section-header title="Rozliczenie retr"/>

                <router-link
                    :to="{ name: 'reclamations' }"
                    class="btn btn-sm btn-secondary"
                >
                    Reklamacje
                </router-link>
            </div>

            <selected-filters
                class="mb-4"
                :module-name="moduleName"
                :filters="filters"
                @applyFilters="applyFilters"
            />

            <page-preloader v-if="status === 'loading'" />

            <retr-list v-else-if="hasData" :retr="retr" />

            <div v-else-if="!isLocationIdSelected">
                Wybierz sklep w filtrze, aby wyświetlić raport
            </div>

            <contact-placeholder v-else />
        </template>
    </left-side-filters>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { registerPageModule } from '@/utils/store'
import ReclamationButtonMixin from '@/components/my-business/retr/reclamation-button.mixin'
import RetroStore from '@/store/modules/my-business/retr.module'
import RetrReclamationsStore from '@/store/modules/my-business/retr-reclamations.module'
import LeftSideFilters from '@/components/layout/LeftSideFilters'
import RetrList from '@/components/my-business/retr/RetrList'

export default {
    name: 'Retr',

    mixins: [ReclamationButtonMixin],

    beforeCreate() {
        registerPageModule(this.$store, RetroStore, 'retr')
        registerPageModule(this.$store, RetrReclamationsStore, 'retrReclamations')
    },

    components: {
        LeftSideFilters,
        RetrList
    },

    data() {
        return {
            title: 'Retr',
            moduleName: 'retr'
        }
    },

    computed: {
        ...mapGetters('retr', ['filters', 'retr', 'status', 'canComplaint', 'hasData']),

        isLocationIdSelected() {
            return !!this.filters.locationId.value
        }
    },

    methods: {
        ...mapActions('retr', [
            'loadRetr',
            'loadReclamationDates',
            'setDefaultLocationIdAndQuarter'
        ]),

        fetch() {
            this.loadRetr()

            if (this.hasData) {
                this.loadReclamationDates()
            }
        },

        applyFilters() {
            this.fetch()
        }
    },

    async created() {
        // Force update getLocationsByNetworkAlias getter
        this.$store.commit('retr/SET_ALIAS', this.$route.params.alias)

        await this.setDefaultLocationIdAndQuarter()

        if (this.hasData) {
            this.loadReclamationDates()
        }
    }
}
</script>

<style lang="scss">
.retr {
    &__tooltip {
        list-style-type: none;
        padding: 0;
        margin: 0;
        li {
            margin: 0;
            padding: 0;
        }
    }
}
</style>